/**
 * Tenant misc keys for destinations managed on the Connections page
 * (OAuth / platform authorization, an account, or a role in the customer's AWS account, before export).
 * Extend this list when another destination needs that page.
 */
export const CONNECTION_REQUIRING_MISC_KEYS = [
  'meta',
  'tradeDesk',
  'amazonS3',
] as const;

/** Misc key union for connection-requiring export destinations. */
export type ConnectionRequiringMiscKey =
  (typeof CONNECTION_REQUIRING_MISC_KEYS)[number];

/**
 * Id of the Amazon S3 export destination (SPYG-2627). Fixed in the API
 * migration, so it is the same in every environment; the destination is also
 * matched by its name, "Amazon S3".
 */
export const AMAZON_S3_EXPORT_DESTINATION_ID =
  '694aea9d-1bfe-4e10-b10c-b2d1415fcb4d';
